// src/services/storage.js
const STORAGE_KEY = 'faraone_app_state';

export const storage = {
  saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (error) {
      console.error('Error saving state:', error);
    }
  },

  loadState() {
    try {
      const state = localStorage.getItem(STORAGE_KEY);
      return state ? JSON.parse(state) : null;
    } catch (error) {
      console.error('Error loading state:', error);
      return null;
    }
  },

  clearState() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      console.error('Error clearing state:', error);
    }
  }
};
